<template>
    <div>
        <div class="giving-bottom-banner"
             v-if="isGiveBannerEnabledInPlayer && (isGivingBannerShow || isTimeframeBannerVisible)">
            <div class="accordion" role="tablist">
                <div class="accordion-item mb-1">
                    <div id="expande-collapse-btn-div" class="accordion-header text-center" @click="toggleAccordion"
                         role="tab" :style="{
                            'background-color' : streamSettings.give_banner.colors.background
                        }">
                        <button class="expande-collapse-btn" type="button" :style="{
                                'background-color' : streamSettings.give_banner.colors.background
                            }">
                            <svg width="30" height="30" v-if="!isGivingBottomBarOpen" viewBox="0 0 30 30" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <g opacity="0.7">
                                    <path
                                        d="M18.9375 18L15 14.0625L11.0625 18L10.1875 17.0625L15 12.25L19.8125 17.0625L18.9375 18Z"
                                        :fill="streamSettings.give_banner.colors.text"/>
                                </g>
                            </svg>
                            <svg width="30" height="30" v-else viewBox="0 0 30 30" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <g opacity="0.7">
                                    <path
                                        d="M15 18L10.1875 13.1875L11.0625 12.25L15 16.1875L18.9375 12.25L19.8125 13.1875L15 18Z"
                                        :fill="streamSettings.give_banner.colors.text"/>
                                </g>
                            </svg>
                        </button>
                    </div>
                    <div
                        :class="{
                            'accordion-body open': isGivingBottomBarOpen,
                            'accordion-body': !isGivingBottomBarOpen
                        }"
                        :style="{
                            'background-color': streamSettings.give_banner.colors.background
                        }"
                    >
                        <div class="row pb-4">
                            <div class="col-md-8 col-lg-8 col-sm-12 text-center main-text-area">
                                <div class="giving-banner-text">
                                    <span class="giving-bottom-bar-text" :class="descriptionClass" :style="{
                                        color: streamSettings.give_banner.colors.text
                                    }">{{ streamSettings.give_banner.description }}</span>
                                    <br/>
                                    <button
                                        :disabled="disableGiveButtonForDashboard"
                                        @click="openGiveModel"
                                        class="mt-3 give-now-btn btn btn-large-screen"
                                        :style="{
                                            'background-color': streamSettings.give_banner.colors.button,
                                            'color': streamSettings.give_banner.colors.text
                                        }"
                                    >
                                        {{ streamSettings.give_banner.button_text }}
                                    </button>
                                </div>
                                <button
                                    :disabled="disableGiveButtonForDashboard"
                                    @click="openGiveModel"
                                    class="give-now-btn btn  btn-sm btn-small-screen d-md-none d-lg-none d-sm-inline-block"
                                    :style="{
                                            'background-color': streamSettings.give_banner.colors.button,
                                            'color': streamSettings.give_banner.colors.text
                                        }"
                                >
                                    {{ streamSettings.give_banner.button_text }}
                                </button>
                            </div>
                            <div class="col-4 d-none d-md-block d-lg-block d-sm-none">
                                <img
                                    v-if="streamSettings.give_banner.banner_giving_show_qr_in_banner"
                                    :src="streamSettings.give_banner.banner_giving_qr_code_url"
                                    class="float-left"
                                    height="100"
                                    width="100"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="showPopupModel" class="modal-overlay">
            <div id="custom-give-form-modal" ref="customGiveFormModal" :v-model="showPopupModel" role="dialog"
                 tabindex="-1" class="modal fade show d-block" aria-modal="true">
                <div class="modal-dialog modal-md">
                    <div role="document" id="custom-give-form-modal___BV_modal_content_"
                         aria-labelledby="custom-give-form-modal___BV_modal_header_"
                         aria-describedby="custom-give-form-modal___BV_modal_body_" class="modal-content">
                        <div>
                            <!-- Custom Loader - how spinner while the script is being loaded  -->
                            <div v-if="isLoadingGracePeriod" class="custom-loader-container">
                                <div class="custom-loader"></div>
                                <p>Loading...</p>
                            </div>

                            <!-- Show message only if the script has failed -->
                            <div v-if="!giveFormScriptLoaded && !isLoadingGracePeriod" class="give-form-not-found">
                                <p>Give Form is not available at the moment.</p>
                            </div>

                            <!-- The form container should always be present -->
                            <div id="popup-give-form-container">
                                <span v-if="!isLoadingGracePeriod" class="close" @click="hideGivePopupModal">×</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div tabindex="0"></div>
            <div id="custom-give-form-modal___BV_modal_backdrop_" class="modal-backdrop fade show"></div>
        </div>
    </div>
</template>

<script>

import debounce from 'lodash/debounce';

export default {
    props: {
        streams: Object,
        streamSettings: Object,
        isStreaming: Boolean,
        disableGiveButtonForDashboard: Boolean,
    },
    watch: {
        // Watch for changes to the `isStreaming` prop
        isStreaming(newValue) {
            // Perform any additional logic when the stream status changes
            this.isGiveBannerVisible();
        },
        streamSettings: {
            handler() {
                //This should be runs every time the data changes.
                this.isGiveBannerVisible();
            },
            deep: true,
            immediate: true
        }

    },
    data() {
        return {
            currentStream: undefined,
            dark: true,
            isGivingBannerShow: false,
            isGivingBottomBarOpen: false,
            showPopupModel: false,
            giveFormScriptLoaded: false,
            isTimeframeBannerVisible: false,
            isSetTimeBannerVisible: false, // For set time banner visibility
            isLoadingGracePeriod: false // Add a grace period flag
        }
    },
    computed: {
        isGiveBannerEnabledInPlayer() {

            const isGlobalEnabled =
                this.streamSettings &&
                this.streamSettings.give_banner &&
                this.streamSettings.give_banner.banner_giving_show_banner_in_player;

            const isStreamWiseEnabled = (this.streams && this.streams.data && this.streams.data.length > 0) ? this.streams.data[0].giving_banner : 0;

            if (Number(isStreamWiseEnabled) === 0) {
                return false; // If stream specific banner is disabled
            } else {
                return (!isGlobalEnabled) ? false : true; // If global banner is disabled return false else true.
            }
        },
        descriptionClass() {
            return this.streamSettings.give_banner.description.length <= 30 ? 'line-one' : 'line-two';
        }
    },
    created() {
        this.currentStream = this.streams ? this.streams.data[0] : null;
        // Now we can safely set isGivingBannerShow with initialized isStreaming
        this.isGiveBannerVisible();
    },
    methods: {
        toggleAccordion() {
            const delay = this.isGivingBottomBarOpen ? 100 : 30; // Set delay dynamically

            this.isGivingBottomBarOpen = !this.isGivingBottomBarOpen;

            setTimeout(() => {
                const height = document.body.offsetHeight;
                window.parent.postMessage(['AccordionChange', height], '*');
            }, delay);
        },

        openGiveModel() {
            this.showPopupModel = true;

            const scriptSource = this.streamSettings.give_banner.banner_giving_form_url;
            const externalcss = this.streamSettings.give_banner.externalcss;

            // Extract the domain and formid
            const url = new URL(scriptSource);
            const endpoint = `${url.protocol}//${url.host}`; // Extract the domain
            const formId =  url.searchParams.get("formid"); // Extract the formid parameter

            let externalJsonData = (this.currentStream) ? `stream_id:${this.currentStream.id},form_experience:banner` : '';

            // Construct the new URL
            // SourceID 16 is for Streaming Banner (Bottom banner)
            const newScriptSource = `${endpoint}/embed.aspx?formId=${formId}&set-page-title=false&button-class=sites-button&use-default-theme=true&button-class=sites-button&style-url=${externalcss}&source=16&external-data=${externalJsonData}`;

            // Ensure the script is injected after the modal is rendered
            this.$nextTick(() => {
                this.injectGiveForm("popup-give-form-container", newScriptSource);
            });
        },

        /**
         * Inject the Give Form Script dynamically into the DOM
         */
        injectGiveForm(targetElementId, scriptSource) {
            if (!scriptSource) {
                console.error("Give Form script source URL is missing.");
                return;
            }

            const container = document.getElementById(targetElementId);

            if (!container) {
                console.error(`Target element with ID "${targetElementId}" not found.`);
                return;
            }

            // Start a grace period timer
            this.isLoadingGracePeriod = true;

            // Check if the script is already loaded
            if (!document.querySelector(`#${targetElementId} script`)) {
                const script = document.createElement("script");
                script.id = "giveFormScript";
                script.src = scriptSource;
                script.async = true;

                // Mark the script as loaded once it finishes loading
                script.onload = () => {
                    this.giveFormScriptLoaded = true;
                    this.markIsLoadingGracePeriodFalse(); // End the grace period immediately if script is already loaded
                };

                script.onerror = () => {
                    this.markIsLoadingGracePeriodFalse(); // End the grace period immediately if script is already loaded
                    console.error("Failed to load the Give Form script.");
                };

                // Append the script to the container
                container.appendChild(script);
            } else {
                this.giveFormScriptLoaded = true; // Mark as loaded if already present
                this.markIsLoadingGracePeriodFalse(); // End the grace period immediately if script is already loaded
            }
        },

        hideGivePopupModal() {
            this.showPopupModel = false;

            // Reset the flags
            this.giveFormScriptLoaded = false;
            this.isLoadingGracePeriod = true;
        },

        markIsLoadingGracePeriodFalse() {
            setTimeout(() => {
                this.isLoadingGracePeriod = false; // End the grace period after script loads
            }, 1000); // Adjust the timeout as needed
        },

        /**
         * The function use to control the give banner visibility
         */
        isGiveBannerVisible() {
            const streamSettingsData = this.streamSettings;

            if (!streamSettingsData || !streamSettingsData.give_banner || !streamSettingsData.give_banner.banner_visibility) {
                // If streamSettings, give_banner, or banner_visibility is not defined, hide the banner
                this.isGivingBannerShow = false;
                this.isGivingBottomBarOpen = false;
                this.isTimeframeBannerVisible = false;
                return;
            }

            const bannerVisibility = streamSettingsData.give_banner.banner_visibility;
            const hasType = bannerVisibility.hasOwnProperty('type');
            const hasExpandedMode = bannerVisibility.hasOwnProperty('expanded_mode');

            if (hasType && hasExpandedMode) {
                const isAlwaysShow = bannerVisibility.type === 'always_show';
                const isControlWhileLive = bannerVisibility.type === 'control_while_live';
                const isSetTime = bannerVisibility.type === 'set_time';
                const isExpandedMode = bannerVisibility.expanded_mode === true;

                if (isSetTime) {
                    this.isSetTimeBannerVisible = true;
                    this.isGivingBannerShow = false;
                    this.isGivingBottomBarOpen = true;
                    this.checkBannerVisibility(); // Delegate visibility checks to checkBannerVisibility
                    this.setupTimer(); // Ensure the timer is set up for periodic checks
                } else if ((isAlwaysShow && isExpandedMode) || (isControlWhileLive && this.isStreaming && isExpandedMode)) {
                    this.isGivingBannerShow = true;
                    this.isGivingBottomBarOpen = true;
                    this.isTimeframeBannerVisible = false;
                    this.isSetTimeBannerVisible = false;
                } else if (isControlWhileLive && this.isStreaming && !isExpandedMode) {
                    this.isGivingBannerShow = true;
                    this.isGivingBottomBarOpen = false;
                    this.isTimeframeBannerVisible = false;
                    this.isSetTimeBannerVisible = false;
                } else {
                    this.isGivingBannerShow = false;
                    this.isGivingBottomBarOpen = false;
                    this.isTimeframeBannerVisible = false;
                    this.isSetTimeBannerVisible = false;
                }
            } else {
                // If type or expanded_mode is not defined, hide the banner
                this.isGivingBannerShow = false;
                this.isGivingBottomBarOpen = false;
                this.isTimeframeBannerVisible = false;
                this.isSetTimeBannerVisible = false;
            }
        },

        checkBannerVisibility: debounce(function () {

            // Ensure timeframes exist and currentStream is valid
            if (!this.currentStream || !this.isStreaming || !this.streamSettings.give_banner.timeframes || !this.isSetTimeBannerVisible) {
                this.isTimeframeBannerVisible = false;
                return;
            }

            try {
                const timeframes = JSON.parse(this.streamSettings.give_banner.timeframes);
                // Sort timeframes by showAfter in ascending order
                timeframes.sort((a, b) => parseFloat(a.showAfter) - parseFloat(b.showAfter));

                const streamStart = new Date(this.currentStream.start.carbon).getTime();
                const streamEnd = new Date(this.currentStream.end.carbon).getTime();
                const totalStreamMinutes = (streamEnd - streamStart) / 60000;
                const currentTime = Date.now();
                const elapsedMinutes = (currentTime - streamStart) / 60000;

                // Check if current time is within any valid timeframe
                this.isTimeframeBannerVisible = timeframes.some(({showAfter, showFor}) => {
                    const showAfterMinutes = parseFloat(showAfter);
                    const showForMinutes = parseFloat(showFor);

                    // Ignore timeframes that exceed the total stream length
                    if (showAfterMinutes + showForMinutes > totalStreamMinutes) {
                        return false;
                    }

                    return elapsedMinutes >= showAfterMinutes && elapsedMinutes <= showAfterMinutes + showForMinutes;
                });
            } catch (error) {
                console.error("Error parsing timeframes:", error);
                this.isTimeframeBannerVisible = false;
            }
        }, 500), // Debounce for 500ms

        // Setup a timer to check banner visibility every minute
        setupTimer() {
            if (this.isSetTimeBannerVisible) {
                // Recheck banner visibility every minute
                this.intervalId = setInterval(() => {
                    this.checkBannerVisibility();
                }, 30000);
            }
        },
    }
}
</script>


<style lang="scss" scoped>
@import '~bootstrap/scss/functions';
@import '~bootstrap/scss/variables';
@import '~bootstrap/scss/mixins';

// For Giving Banner
::v-deep {
    .accordion-body {
        max-height: 0;
        overflow: hidden;
        opacity: 0;
        transition: max-height 1.2s ease-in-out,
        opacity 1.2s ease-in-out,
        padding 1s ease-in-out;
        padding: 0 10px;
        background-color: inherit; /* Dynamically set background color */
    }

    .accordion-body.open {
        max-height: 500px; /* Adjust according to content */
        opacity: 1;
        padding: 10px; /* Add spacing */
    }

    .expande-collapse-btn {
        border-radius: 0%;
        border: 0px;
        box-shadow: none;
        cursor: pointer;
    }

    .give-now-btn {
        padding: 8px 16px;
        font-size: 16px;
        line-height: 24px;
        margin-top: 14px;
        margin-left: 16px;
        font-weight: 600;
    }

    .giving-bottom-bar-text {
        color: #FFFFFF;
        padding-left: 20px;
        font-size: 20px !important;
        font-style: normal !important;
        font-weight: 700 !important;
        line-height: 28px !important; /* 140% */
    }

    .giving-banner-text {
        width: 50%;
        text-align: center;
        float: right;
    }

    #accordion-1 > .card-body > .giving-bottom-bar-text {
        color: #FFFFFF;
        /* Heading 4 */
        font-size: 1.25em !important;
        font-style: normal !important;
        font-weight: 700 !important;
        line-height: 28px !important; /* 140% */
    }

}

// For Giving Banner  Give Now Popup.
::v-deep {
    .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 999;
        background: rgba(0, 0, 0, 0.5);
    }

    .close {
        font-size: 1.5rem;
        font-weight: bold;
        line-height: 1;
        color: #000;
        opacity: 0.5;
        cursor: pointer;
        position: relative;
        top: 68px;
        right: 15px;
        display: flex;
        width: 22px;
    }

    .close:hover {
        color: #000;
        text-decoration: none;
        cursor: pointer;
        opacity: 0.75;
    }

    .give-form-not-found {
        height: 80vh;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    #custom-give-form-modal iframe {
        height: 80vh;
        width: 100%;
    }

    #popup-give-form-container {
        height: calc(100vh - 30px) !important;
        width: 616px !important;
        overflow: auto; /* Allow scrolling if content exceeds height */
    }

    /* Media query for mobile view */
    @media (max-width: 767.98px) {
        #popup-give-form-container {
            width: 100% !important;
            min-width: 0 !important;
            max-width: 100vw !important;
            overflow: auto;
            height: calc(100vh - 30px) !important;
            scrollbar-width: none;
        }
    }
}

.custom-loader-container {
    height: 80vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    color: #666;
}

.custom-loader {
    border: 4px solid #f3f3f3; /* Light grey */
    border-top: 4px solid #3498db; /* Blue */
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}


// For screens sized "lg" and wider
@include media-breakpoint-up(lg) {
    ::v-deep {
        .accordion-body {
            max-height: 0;
            overflow: hidden;
            opacity: 0;
            transition: max-height 1.2s ease-in-out,
            opacity 1.2s ease-in-out,
            padding 1s ease-in-out;
            padding: 0 10px;
            background-color: inherit; /* Dynamically set background color */
        }

        .accordion-body.open {
            max-height: 500px; /* Adjust according to content */
            opacity: 1;
            padding: 10px;
        }

        .expande-collapse-btn {
            border-radius: 0%;
            border: 0px;
            box-shadow: none;
            cursor: pointer;
        }

        .give-now-btn {
            padding: 8px 16px;
            font-size: 16px;
            line-height: 24px;
            margin-top: 14px;
            margin-left: 16px;
            font-weight: 600;
        }

        .btn-small-screen {
            display: none;
        }

        .btn-large-screen {
            display: inline-block;
        }

        .giving-bottom-bar-text {
            color: #FFFFFF;
            /* Heading 4 */
            font-size: 20px !important;
            font-style: normal !important;
            font-weight: 700 !important;
            line-height: 28px !important; /* 140% */
        }

        .giving-banner-text {
            width: 50%;
            text-align: center;
            float: right;
        }

        #accordion-1 > .card-body > .giving-bottom-bar-text {
            color: #FFFFFF;
            /* Heading 4 */
            font-size: 1.25em !important;
            font-style: normal !important;
            font-weight: 700 !important;
            line-height: 28px !important; /* 140% */
        }
    }
}

@include media-breakpoint-down(md) {
    .btn-small-screen {
        display: none;
    }

    .btn-large-screen {
        display: inline-block;
    }
}

@include media-breakpoint-down(sm) {
    // Here need to do mobile design.
    .accordion-body {
        max-height: 0;
        overflow: hidden;
        opacity: 0;
        transition: max-height 1.2s ease-in-out,
        opacity 1.2s ease-in-out,
        padding 1s ease-in-out;
        padding: 0 10px;
        background-color: inherit; /* Dynamically set background color */
    }

    .accordion-body.open {
        width: 100%;
        height: 80px;
        flex-shrink: 0;
        opacity: 1;
        // padding: 10px; /* Add spacing */
    }

    .expande-collapse-btn {
        border-radius: 0%;
        border: 0px;
        box-shadow: none;
        cursor: pointer;
        height: 20px !important;
        width: 20px !important;
    }

    .give-now-btn {
        margin-top: 0px;
        display: flex;
        height: 24px;
        min-width: 72px;
        padding: 4px 8px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 10px;

        float: right;
        text-align: center;
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: 16px; /* 133.333% */

        max-width: 90px;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: middle;
        display: inline-block;
        overflow: hidden;
    }

    .main-text-area {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        min-height: 60px;
    }

    .btn-small-screen {
        display: inline-block;
    }

    .btn-large-screen {
        display: none;
    }

    .giving-bottom-bar-text {
        color: #FFFFFF;
        font-size: 16px !important;
        font-style: normal !important;
        font-weight: 600 !important;
        line-height: 24px !important; /* 140% */
    }

    .line-one {
        font-size: 16px !important;
        line-height: 24px !important;
    }

    .line-two {
        font-size: 12px !important;
        line-height: 20px !important;
    }

    .giving-banner-text {
        width: 70%;
    }

    #accordion-1 > .card-body > .giving-bottom-bar-text {
        color: #FFFFFF;
        /* Heading 4 */
        font-size: 1.25em !important;
        font-style: normal !important;
        font-weight: 700 !important;
        line-height: 28px !important; /* 140% */
    }
}

</style>
